import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	importInProgressDescription: {
		id: 'project-create-import-progress.import-progress-button.progress-button.popover-content.import-in-progress-description',
		defaultMessage: 'You can still work on other things while we’re importing your data.',
		description: 'Description for import progress popover',
	},
	importCompleteDescription: {
		id: 'project-create-import-progress.import-progress-button.progress-button.popover-content.import-complete-description',
		defaultMessage:
			'Refresh the page to see the {count, plural, one {# issue} other {# issues}} in your new project.',
		description: 'Description for import complete popover',
	},
	importInCompleteDescription: {
		id: 'project-create-import-progress.import-progress-button.progress-button.popover-content.import-in-complete-description',
		defaultMessage:
			'We couldn’t create {failed} of your {total} {total, plural, one {issue} other {issues}}. See the error log to understand what went wrong.',
		description: 'Description for import incomplete popover',
	},
	importInCompleteDescriptionWithoutErrorLogs: {
		id: 'project-create-import-progress.import-progress-button.progress-button.popover-content.import-in-complete-description-without-error-logs',
		defaultMessage:
			'Try again in a few minutes. Contact support if you continue to experience problems with your import.',
		description: 'Description for import incomplete popover when error logs are absent',
	},
});
